import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchPaymentRequestDetails,
  approvePaymentRequest,
  attestPaymentRequest,
  verifyPaymentRequest,
  rejectPaymentRequest,
  payPaymentRequest,
  queryPaymentRequestComment,
  commentPaymentRequestReject,
  fetchPaymentRequestVouchers,
  fetchSupportingDocument,
} from "../../../../contents/redux/actions/paymentRequestActions.js";
import { fetchWorkflowRouteActors } from "../../../../contents/redux/actions/workflowRouteActions";
import styles from "../../../utilities/cssmodules/ViewPaymentVoucher.module.css";
import {
  CalendarMonthRounded,
  DoneAllRounded,
  DoneRounded,
  DoNotDisturbAltRounded,
  EditRounded,
  HelpOutlineRounded,
  LiveHelpRounded,
  LowPriorityRounded,
  MonetizationOnRounded,
  PaymentsRounded,
  PersonRounded,
  PriceCheckRounded,
  TaskAltRounded,
  WorkRounded,
  DescriptionRounded,
  TableChartRounded,
} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import {
  Tooltip,
  Button,
  IconButton,
  Modal,
  Box,
  Typography,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import QueryModal from "./QueryModal.js";
import RejectCommentModal from "./RejectCommentModal.js";
import VoucherModal from "./VoucherModal.js";
import PayModal from "./PayModal.js";
import { toast } from "react-toastify";

const ViewPaymentVoucher = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const requestDetails = useSelector(
    (state) => state.paymentRequest.paymentRequestDetails,
  );
  const paymentRequestVouchers = useSelector(
    (state) => state.paymentRequest.paymentRequestVouchers || null,
  );
  const supportingDocument = useSelector(
    (state) => state.paymentRequest.supportingDocument || null,
  );

  // Select rolePermissions from Redux state
  const { rolePermissions } = useSelector((state) => ({
    rolePermissions: state.auth?.loggedInUserRolePermissions || [],
  }));

  const goBack = () => {
    navigate(-1);
  };

  const loggedInUserRole = localStorage.getItem("loggedInUserRole");
  const loggedInUserRoleId = parseInt(
    localStorage.getItem("loggedInUserRoleId"),
    10,
  );

  const location = useLocation();
  const { requestId, requestType, createdOn, requester } = location.state || {};

  console.log("ViewPaymentVoucher - requestId:", requestId);
  console.log("ViewPaymentVoucher - requester:", requester);
  console.log("ViewPaymentVoucher - paymentCode:", requestDetails?.paymentCode);
  console.log("ViewPaymentVoucher - Redux requestDetails:", requestDetails);
  console.log(
    "ViewPaymentVoucher - Redux paymentRequestVouchers:",
    paymentRequestVouchers,
  );
  console.log(
    "ViewPaymentVoucher - Redux supportingDocument:",
    supportingDocument,
  );

  const [userPermissions, setUserPermissions] = useState([]);
  const [isQueryModalOpen, setIsQueryModalOpen] = useState(false);
  const [isRejectCommentModalOpen, setIsRejectCommentModalOpen] =
    useState(false);
  const [isVoucherModalOpen, setIsVoucherModalOpen] = useState(false);
  const [isPayModalOpen, setIsPayModalOpen] = useState(false);
  const [workflowId, setWorkflowId] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isLoadingVoucher, setIsLoadingVoucher] = useState(false);
  const [isLoadingSupportingDocument, setIsLoadingSupportingDocument] =
    useState(false);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  // Determine if action buttons should be hidden for HR Assistance
  const hasMasterActorViewPermission = rolePermissions.some(
    (perm) =>
      perm.permissionCategoryId === "MasterActor" &&
      perm.permissionId === "View",
  );
  const hideActions =
    loggedInUserRole === "HR Assistance" &&
    !hasMasterActorViewPermission &&
    requester === "Stiffinnie Saunders" &&
    requestDetails?.currentRole !== loggedInUserRoleId;

  // Determine if action buttons should be shown for Manager
  const isManager = loggedInUserRole === "Manager";
  const hasWorkflowPermissions =
    requestDetails?.workflowPermissions?.length > 0;
  const isCurrentRoleInPermissions = requestDetails?.workflowPermissions?.some(
    (perm) => perm.roleId === requestDetails?.currentRole,
  );
  const isCurrentRoleMatchingUserRole =
    requestDetails?.currentRole === loggedInUserRoleId;
  const showManagerActions =
    isManager &&
    hasWorkflowPermissions &&
    isCurrentRoleInPermissions &&
    isCurrentRoleMatchingUserRole;

  useEffect(() => {
    console.log(
      "useEffect - Mounting with requestId:",
      requestId,
      "requestType:",
      requestType,
    );
    if (requestId && requestType) {
      console.log("Fetching payment request details for requestId:", requestId);
      dispatch(fetchPaymentRequestDetails(requestId, requestType));
      console.log("Fetching supporting document for requestId:", requestId);
      setIsLoadingSupportingDocument(true);
      dispatch(fetchSupportingDocument(requestId)).finally(() =>
        setIsLoadingSupportingDocument(false),
      );
    } else {
      console.warn("Missing requestId or requestType:", {
        requestId,
        requestType,
      });
    }
    return () => {
      console.log("useEffect - Cleanup on unmount");
      if (supportingDocument?.url) {
        console.log("Revoking supportingDocument URL:", supportingDocument.url);
        URL.revokeObjectURL(supportingDocument.url);
      }
    };
  }, [requestId, requestType, dispatch, supportingDocument?.url]);

  useEffect(() => {
    if (requestDetails) {
      const id = requestDetails?.workflowPermissions?.[0]?.workflowId;
      setWorkflowId(id);
      console.log("Workflow ID:", id);

      const loggedInUserId = parseInt(
        localStorage.getItem("loggedInUserId"),
        10,
      );
      console.log(
        "Logged-in User ID:",
        loggedInUserId,
        "Role:",
        loggedInUserRole,
        "Role ID:",
        loggedInUserRoleId,
      );
      console.log("Current Role:", requestDetails.currentRole);

      const permissions = showManagerActions
        ? requestDetails?.workflowPermissions
            ?.filter((perm) => perm.roleId === requestDetails?.currentRole)
            ?.map((perm) => perm.permissionName) || []
        : !isManager
          ? requestDetails?.workflowPermissions
              ?.filter((perm) => perm.roleId === requestDetails?.currentRole)
              ?.map((perm) => perm.permissionName) || []
          : [];
      setUserPermissions(permissions);
      console.log("User Permissions:", permissions);
    }
  }, [
    requestDetails,
    showManagerActions,
    isManager,
    loggedInUserRoleId,
    loggedInUserRole,
  ]);

  useEffect(() => {
    if (workflowId) {
      console.log("Fetching workflow actors for workflowId:", workflowId);
      dispatch(fetchWorkflowRouteActors(workflowId));
    }
  }, [workflowId, dispatch]);

  useEffect(() => {
    console.log(
      "useEffect - paymentRequestVouchers changed:",
      paymentRequestVouchers,
    );
    if (paymentRequestVouchers?.url) {
      console.log("Setting pdfUrl:", paymentRequestVouchers.url);
      setPdfUrl(paymentRequestVouchers.url);
      console.log("Opening VoucherModal");
      setIsVoucherModalOpen(true);
    } else {
      console.log("No valid URL in paymentRequestVouchers");
    }
    return () => {
      console.log("useEffect - Cleanup paymentRequestVouchers");
      if (paymentRequestVouchers?.url) {
        console.log(
          "Revoking paymentRequestVouchers URL:",
          paymentRequestVouchers.url,
        );
        URL.revokeObjectURL(paymentRequestVouchers.url);
      }
    };
  }, [paymentRequestVouchers]);

  const getFileIcon = (contentType) => {
    if (contentType?.startsWith("image/")) {
      return <ImageIcon />;
    }
    if (contentType === "application/pdf") {
      return <PictureAsPdfIcon />;
    }
    if (
      contentType === "application/msword" ||
      contentType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      return <DescriptionRounded />;
    }
    if (
      contentType === "application/vnd.ms-excel" ||
      contentType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      return <TableChartRounded />;
    }
    return <PictureAsPdfIcon />;
  };

  const handleOpenLightbox = (event) => {
    event.preventDefault();
    if (supportingDocument?.contentType?.startsWith("image/")) {
      console.log("Opening lightbox for image:", supportingDocument.url);
      setIsLightboxOpen(true);
    } else if (supportingDocument?.contentType === "application/pdf") {
      console.log("Opening lightbox for PDF:", supportingDocument.url);
      setIsLightboxOpen(true);
    } else {
      console.log(
        "Lightbox not supported for contentType:",
        supportingDocument?.contentType,
      );
      toast.info("Preview is only available for images and PDF documents.");
    }
  };

  const handleCloseLightbox = () => {
    console.log("Closing lightbox");
    setIsLightboxOpen(false);
  };

  const handleVoucherModal = async () => {
    if (!requestId) {
      console.error("Request ID is missing");
      toast.error("Request ID is missing.");
      return;
    }
    if (!requestDetails?.paymentCode) {
      console.error("Payment code is missing");
      toast.error("Payment code is missing.");
      return;
    }
    console.log(
      "Fetching voucher - requestId:",
      requestId,
      "paymentCode:",
      requestDetails.paymentCode,
    );
    setIsLoadingVoucher(true);
    try {
      let documentType = "PaymentVoucher";
      const payload = await dispatch(
        fetchPaymentRequestVouchers(
          requestId,
          requestDetails.paymentCode,
          documentType,
        ),
      );
      console.log("Voucher fetch successful:", payload);
      setIsLoadingVoucher(false);
      setTimeout(() => setIsLoadingVoucher((prev) => prev), 0);
      if (payload?.url) {
        console.log("Fallback: Setting pdfUrl and opening modal");
        setPdfUrl(payload.url);
        setIsVoucherModalOpen(true);
      }
    } catch (error) {
      console.error("Failed to fetch voucher:", error);
      toast.error(
        "Failed to fetch voucher: " + (error.message || "Unknown error"),
      );
      setIsLoadingVoucher(false);
      setTimeout(() => setIsLoadingVoucher((prev) => prev), 0);
    }
  };

  const handleQueryModal = () => {
    console.log("Opening QueryModal");
    setIsQueryModalOpen(true);
  };

  const handleRejectCommentModal = () => {
    console.log("Opening RejectCommentModal");
    setIsRejectCommentModalOpen(true);
  };

  const handlePayModal = () => {
    console.log("Opening PayModal");
    setIsPayModalOpen(true);
  };

  const handleQuerySubmit = (props) => {
    const userId = parseInt(localStorage.getItem("loggedInUserId"), 10);
    const requestTypeId = requestDetails?.requestTypeId;
    const isRequester = props.selectedActor?.value.includes("requester-");
    const payload = {
      notes: props.notes,
      userId,
      requestTypeId,
      requestId,
      targetRoleId: isRequester ? null : props.selectedActor?.role,
      targetUserId: isRequester ? props.selectedActor?.role : null,
    };
    dispatch(queryPaymentRequestComment(payload))
      .then(() => {
        if (loggedInUserRole === "Top Management") {
          navigate("/allrequests");
        } else {
          navigate("/pendingrequests");
        }
      })
      .catch((error) => {
        console.error("Error querying request:", error);
        toast.error("Failed to query request: " + (error.message || "Unknown"));
      });
    setIsQueryModalOpen(false);
  };

  const handleRejectCommentSubmit = (props) => {
    const userId = parseInt(localStorage.getItem("loggedInUserId"), 10);
    const requestTypeId = requestDetails?.requestTypeId;
    const payload = {
      notes: props.notes,
      userId,
      requestTypeId,
      requestId,
    };
    dispatch(commentPaymentRequestReject(payload))
      .then(() => {
        if (loggedInUserRole === "Top Management") {
          navigate("/allrequests");
        } else {
          navigate("/pendingrequests");
        }
      })
      .catch((error) => {
        console.error("Error commenting request:", error);
        toast.error(
          "Failed to comment request: " + (error.message || "Unknown"),
        );
      });
    setIsRejectCommentModalOpen(false);
  };

  // const handlePaySubmit = ({
  //   requestId,
  //   paymentCode,
  //   requiresReceipt,
  //   vendorName,
  // }) => {
  //   const userId = parseInt(localStorage.getItem("loggedInUserId"), 10);
  //   if (!requestDetails?.paymentCode) {
  //     toast.error("No paymentCode associated with this request.");
  //     return;
  //   }
  //   if (
  //     parseInt(paymentCode, 10) !== parseInt(requestDetails.paymentCode, 10)
  //   ) {
  //     toast.error("Invalid paymentCode. Please try again.");
  //     return;
  //   }
  //   if (!userId) {
  //     console.error("User ID is missing");
  //     toast.error("User ID is missing.");
  //     return;
  //   }
  //   dispatch(
  //     payPaymentRequest(
  //       requestId,
  //       paymentCode,
  //       requiresReceipt,
  //       vendorName,
  //       userId,
  //     ),
  //   )
  //     .then(() => {
  //       if (loggedInUserRole === "Top Management") {
  //         navigate("/allrequests");
  //       } else {
  //         navigate("/pendingrequests");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error paying request:", error);
  //       toast.error(
  //         "Failed to pay request: " + (error.message || "Unknown error"),
  //       );
  //     });
  //   setIsPayModalOpen(false);
  // };

  const handlePaySubmit = ({
    requestId,
    paymentCode,
    requiresReceipt,
    vendorName,
    paymentMethod,
    checkNumber,
    checkDate,
    bank,
    amount,
    currency,
    payTo,
    approvedBy,
    entityType,
  }) => {
    const userId = parseInt(localStorage.getItem("loggedInUserId"), 10);
    if (!requestDetails?.paymentCode) {
      toast.error("No paymentCode associated with this request.");
      return;
    }
    if (
      parseInt(paymentCode, 10) !== parseInt(requestDetails.paymentCode, 10)
    ) {
      toast.error("Invalid paymentCode. Please try again.");
      return;
    }
    if (!userId) {
      console.error("User ID is missing");
      toast.error("User ID is missing.");
      return;
    }
    dispatch(
      payPaymentRequest(
        requestId,
        paymentCode,
        requiresReceipt,
        vendorName,
        userId,
        paymentMethod,
        checkNumber,
        checkDate,
        bank,
        amount,
        currency,
        payTo,
        approvedBy,
        entityType,
      ),
    )
      .then(() => {
        if (loggedInUserRole === "Top Management") {
          navigate("/allrequests");
        } else {
          navigate("/pendingrequests");
        }
      })
      .catch((error) => {
        console.error("Error paying request:", error);
        toast.error(
          "Failed to pay request: " + (error.message || "Unknown error"),
        );
      });
    setIsPayModalOpen(false);
  };

  const handleApprove = () => {
    const userId = parseInt(localStorage.getItem("loggedInUserId"), 10);
    if (!requestId) {
      console.error("Request ID is missing");
      toast.error("Request ID is missing.");
      return;
    }
    if (!userId) {
      console.error("User ID is missing");
      toast.error("User ID is missing.");
      return;
    }
    dispatch(approvePaymentRequest(requestId, userId))
      .then(() => {
        if (loggedInUserRole === "Top Management") {
          navigate("/allrequests");
        } else {
          navigate("/pendingrequests");
        }
      })
      .catch((error) => {
        console.error("Error approving request:", error);
        toast.error(
          "Failed to approve request: " + (error.message || "Unknown error"),
        );
      });
  };

  const handleAttest = () => {
    if (requestId) {
      dispatch(attestPaymentRequest(requestId))
        .then(() => {
          if (loggedInUserRole === "Top Management") {
            navigate("/allrequests");
          } else {
            navigate("/pendingrequests");
          }
        })
        .catch((error) => {
          console.error("Error attesting request:", error);
          toast.error(
            "Failed to attest request: " + (error.message || "Unknown error"),
          );
        });
    }
  };

  const handleVerify = () => {
    if (requestId) {
      dispatch(verifyPaymentRequest(requestId))
        .then(() => {
          if (loggedInUserRole === "Top Management") {
            navigate("/allrequests");
          } else {
            navigate("/pendingrequests");
          }
        })
        .catch((error) => {
          console.error("Error verifying request:", error);
          toast.error(
            "Failed to verify request: " + (error.message || "Unknown error"),
          );
        });
    }
  };

  const handleReject = () => {
    if (requestId) {
      dispatch(rejectPaymentRequest(requestId))
        .then(() => {
          if (loggedInUserRole === "Top Management") {
            navigate("/allrequests");
          } else {
            navigate("/pendingrequests");
          }
        })
        .catch((error) => {
          console.error("Error rejecting request:", error);
          toast.error(
            "Failed to reject request: " + (error.message || "Unknown error"),
          );
        });
    }
  };

  const handleClose = () => {
    if (requestId) {
      dispatch(rejectPaymentRequest(requestId))
        .then(() => {
          if (loggedInUserRole === "Top Management") {
            navigate("/allrequests");
          } else {
            navigate("/pendingrequests");
          }
        })
        .catch((error) => {
          console.error("Error closing request:", error);
          toast.error(
            "Failed to close request: " + (error.message || "Unknown error"),
          );
        });
    }
  };

  return (
    <div className={styles["component-wrapper"]}>
      <div className={styles["component-title"]}>
        <div className={styles["flex-row-container"]}>
          <div className={styles["flex-row-custom-1"]}>
            <span
              className={styles["title-back-button"]}
              onClick={goBack}
              aria-label="Go Back"
            >
              <Tooltip title="Go Back" arrow placement="top">
                <ArrowBackIosIcon />
              </Tooltip>
            </span>
            <span>View {requestType} Request</span>
          </div>
        </div>
      </div>
      <div className={styles["wrapper"]}>
        <div className={styles["generic_request_content_component_wrapper"]}>
          <div className={styles["generic_request_content_wrapper"]}>
            <div className={styles["request-details-header"]}>
              <div className={styles["section-header"]}>Request Details</div>
              <div className={styles["status-container"]}>
                <p>
                  Status:{" "}
                  <span className={styles["status-badge"]}>
                    {requestDetails?.status === "Unknown Status"
                      ? "Archived"
                      : requestDetails?.status || "N/A"}
                  </span>
                </p>
              </div>
            </div>
            <div className={styles["generic_request_content_container"]}>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <PersonRounded /> Requester:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {requester || "N/A"}
                </div>
              </div>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <CalendarMonthRounded /> Date created:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {createdOn
                    ? new Date(createdOn).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : "N/A"}
                </div>
              </div>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <WorkRounded /> Project name:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {requestDetails?.project || "No project name"}
                </div>
              </div>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <MonetizationOnRounded /> Amount requested:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {requestDetails?.amount ? `$${requestDetails.amount}` : "N/A"}
                </div>
              </div>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <PaymentsRounded /> Currency:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {requestDetails?.currency || "N/A"}
                </div>
              </div>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <LiveHelpRounded /> Purpose of request:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {requestDetails?.purpose || "No purpose provided"}
                </div>
              </div>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <EditRounded /> Description:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {requestDetails?.description || "No description provided"}
                </div>
              </div>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <EditRounded /> Comment:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {requestDetails?.comments?.length > 0 ? (
                    <div className={styles["comment_block"]}>
                      <p>
                        {requestDetails.comments[
                          requestDetails.comments.length - 1
                        ].notes.replace(/^\[Query to [^\]]+\]: /, "")}
                      </p>
                      <p className={styles["comment-meta"]}>
                        <strong>Queried By:</strong>{" "}
                        {
                          requestDetails.comments[
                            requestDetails.comments.length - 1
                          ].queriedBy
                        }
                      </p>
                    </div>
                  ) : (
                    "No comments available"
                  )}
                </div>
              </div>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <PictureAsPdfIcon /> Supporting Document:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {supportingDocument?.url ? (
                    <Button
                      href={supportingDocument.url}
                      download={supportingDocument.filename}
                      startIcon={
                        <IconButton
                          onClick={handleOpenLightbox}
                          sx={{ p: 0, mr: 1 }}
                          aria-label="View supporting document"
                        >
                          {getFileIcon(supportingDocument.contentType)}
                        </IconButton>
                      }
                      variant="outlined"
                      className={styles["supporting-document-button"]}
                    >
                      {supportingDocument.filename}
                    </Button>
                  ) : isLoadingSupportingDocument ? (
                    <Typography className={styles["loading-text"]}>
                      Loading supporting document...
                    </Typography>
                  ) : (
                    <Typography className={styles["no-document-text"]}>
                      No supporting document
                    </Typography>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={styles["generic_request_actions_wrapper"]}>
            <div className={styles["actions-header"]}>
              <div className={styles["section-header"]}>Actions</div>
              {!hideActions && (
                <button
                  onClick={handleVoucherModal}
                  className={styles["view-voucher-button"]}
                  disabled={isLoadingVoucher}
                  aria-label="View Voucher"
                >
                  {isLoadingVoucher ? "Loading..." : "View Voucher"}
                </button>
              )}
            </div>
            {!hideActions &&
              requestDetails?.status !== "Paid" &&
              requestDetails?.status !== "Rejected" &&
              (showManagerActions || !isManager) && (
                <div className={styles["generic_request_actions"]}>
                  {userPermissions.includes("Approve") && (
                    <Tooltip title="Second level consent" arrow placement="top">
                      <button
                        onClick={handleApprove}
                        className={styles["generic_request_button_primary"]}
                        aria-label="Approve request"
                      >
                        <TaskAltRounded /> Approve
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions.includes("Attest") && (
                    <Tooltip
                      title="Highest level consent"
                      arrow
                      placement="top"
                    >
                      <button
                        onClick={handleAttest}
                        className={styles["generic_request_button_save"]}
                        aria-label="Attest request"
                      >
                        <DoneAllRounded /> Attest
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions.includes("Query") && (
                    <Tooltip
                      title="Question or recall due to dissatisfaction"
                      arrow
                      placement="top"
                    >
                      <button
                        onClick={handleQueryModal}
                        className={styles["generic_request_button_secondary"]}
                        aria-label="Query request"
                      >
                        <HelpOutlineRounded /> Query
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions.includes("Verify") && (
                    <Tooltip title="First level consent" arrow placement="top">
                      <button
                        onClick={handleVerify}
                        className={styles["generic_request_button_primary"]}
                        aria-label="Verify request"
                      >
                        <DoneRounded /> Verify
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions.includes("Pay") && (
                    <Tooltip title="Initiate payment" arrow placement="top">
                      <button
                        onClick={handlePayModal}
                        className={styles["generic_request_button_primary"]}
                        aria-label="Pay request"
                      >
                        <PriceCheckRounded /> Pay
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions.includes("Reject") && (
                    <Tooltip title="Decline or dismiss" arrow placement="top">
                      <button
                        onClick={handleRejectCommentModal}
                        className={styles["generic_request_button_danger"]}
                        aria-label="Reject request"
                      >
                        <DoNotDisturbAltRounded /> Reject
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions.includes("Close") && (
                    <Tooltip title="End the request flow" arrow placement="top">
                      <button
                        onClick={handleClose}
                        className={styles["generic_request_button_close"]}
                        aria-label="Close request"
                      >
                        <LowPriorityRounded /> Close
                      </button>
                    </Tooltip>
                  )}
                </div>
              )}
          </div>
        </div>
      </div>
      <QueryModal
        open={isQueryModalOpen}
        onClose={() => setIsQueryModalOpen(false)}
        onSubmit={handleQuerySubmit}
        workflowId={workflowId}
        requester={requester}
        requesterId={requestDetails?.requesterId}
      />
      <RejectCommentModal
        open={isRejectCommentModalOpen}
        onClose={() => setIsRejectCommentModalOpen(false)}
        onSubmit={handleRejectCommentSubmit}
        workflowId={workflowId}
        requester={requester}
        requesterId={requestDetails?.requesterId}
      />
      <VoucherModal
        open={isVoucherModalOpen}
        onClose={() => {
          console.log("Closing VoucherModal, revoking pdfUrl:", pdfUrl);
          setIsVoucherModalOpen(false);
          setPdfUrl(null);
        }}
        requestId={requestId}
        pdfUrl={pdfUrl}
        paymentCode={requestDetails?.paymentCode}
      />
      <PayModal
        open={isPayModalOpen}
        onClose={() => setIsPayModalOpen(false)}
        onSubmit={handlePaySubmit}
        requestId={requestId}
      />
      <Modal
        open={isLightboxOpen}
        onClose={handleCloseLightbox}
        aria-labelledby="supporting-document-lightbox"
        className={styles["lightbox-modal"]}
      >
        <Box className={styles["lightbox-box"]}>
          <IconButton
            onClick={handleCloseLightbox}
            className={styles["lightbox-close-button"]}
            aria-label="Close lightbox"
          >
            <CloseIcon />
          </IconButton>
          {supportingDocument?.url &&
          supportingDocument?.contentType?.startsWith("image/") ? (
            <img
              src={supportingDocument.url}
              alt="Supporting Document"
              className={styles["lightbox-image"]}
            />
          ) : supportingDocument?.url &&
            supportingDocument?.contentType === "application/pdf" ? (
            <iframe
              src={supportingDocument.url}
              title="Supporting Document"
              className={styles["lightbox-iframe"]}
            />
          ) : (
            <Typography className={styles["lightbox-error"]}>
              Preview not available for this document type.
            </Typography>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default ViewPaymentVoucher;
